import script from "./slip_details.vue?vue&type=script&setup=true&lang=js"
export * from "./slip_details.vue?vue&type=script&setup=true&lang=js"

import "./slip_details.vue?vue&type=style&index=0&id=532673d6&lang=scss"

const __exports__ = script;

export default __exports__